export const ADD_NEW_FIELD = 'ADD_NEW_FIELD';
export const ADD_STRUCTURE = 'ADD_STRUCTURE';
export const ADD_FIELD = 'ADD_FIELD';
export const ADD_VALUE = 'ADD_VALUE';
export const ADD_SELECT_VALUE = 'ADD_SELECT_VALUE';
export const ADD_ERROR_MESSAGE = 'ADD_ERROR_MESSAGE';
export const DELETE_SELECTED_FIELD = 'DELETE_SELECTED_FIELD';
export const DELETE_VALUE = 'DELETE_VALUE';
export const DELETE_FIELD = 'DELETE_FIELD';
export const RESET_FIELDS = 'RESET_FIELDS';
export const SEARCH_FORM_REQUEST = 'SEARCH_FORM_REQUEST';
export const SEARCH_FORM_SUCCESS = 'SEARCH_FORM_SUCCESS';
export const IS_SEARCHED = 'IS_SEARCHED';
export const GET_SEARCH_REPORT = 'GET_SEARCH_REPORT';
export const DELETE_SEARCH_REPORT = 'DELETE_SEARCH_REPORT';
